export enum EnumInterviewMethod {
  Video = 2,
  Phone = 1,
  'On site' = 0,
}

export interface IInterviewMethod {
  display: string;
  description: string;
  value: EnumInterviewMethod;
}

export const INTERVIEW_CONFIG = [
  {
    display: 'Video',
    value: EnumInterviewMethod.Video,
    description: 'we will host your video interviews through Snagajob',
  },
  {
    display: 'Phone',
    value: EnumInterviewMethod.Phone,
    description: 'we host a conference line for you to join',
  },
  {
    display: 'On-site',
    value: EnumInterviewMethod['On site'],
    description: 'you will host an in-person interview',
  },
];
